import { useCallback } from 'react';
import { getDataType } from 'reporting-data/report/configReportGetters';
import { isUnifiedEventsQLReport } from 'reporting-data/tsTypes/reportTypes';
import { useFetchPropertyGroupsWithFormatter } from '../../hooks/useFetchPropertyGroupsWithFormatter';
const sortOptionsByText = (a, b) => {
  if ((a === null || a === void 0 ? void 0 : a.text) < (b === null || b === void 0 ? void 0 : b.text)) {
    return -1;
  }
  if (a.text > b.text) {
    return 1;
  }
  return 0;
};
const BLOCKLISTED_UEQL_PROPERTIES = ['eventType'];
const useFetchPropertyOptionsForDataColumnsOptionModal = report => {
  const dataType = getDataType(report);
  const isUEQLReport = isUnifiedEventsQLReport(report);
  const resultFormatter = useCallback(response => {
    return response.map(group => {
      const propertyOptions = group.get('properties').filter(prop => {
        return !prop.get('hidden') && !(isUEQLReport && BLOCKLISTED_UEQL_PROPERTIES.includes(prop.get('name')));
      }).map(prop => {
        return {
          text: prop.get('label'),
          value: prop.get('name')
        };
      }).sort(sortOptionsByText);
      return {
        text: group.get('displayName'),
        options: propertyOptions.toList().toJS()
      };
    }).filter(group => {
      return group.options.length;
    }).toList().toJS();
  }, [isUEQLReport]);
  return useFetchPropertyGroupsWithFormatter(dataType, resultFormatter, isUEQLReport);
};
export default useFetchPropertyOptionsForDataColumnsOptionModal;